// extracted by mini-css-extract-plugin
module.exports = {"button":"BarLanding_button__1xUXX"};